// Kit compartido del backoffice E-commerce (esquema ecommerce, scripts 324/325).
import { apiClient } from '@/lib/api/client';

export const ECOM = { headers: { 'Content-Profile': 'ecommerce', 'Accept-Profile': 'ecommerce' } };
export const ecomRpc = async <T,>(fn: string, body: Record<string, unknown> = {}): Promise<T> =>
  (await apiClient.post<T>(`/rpc/${fn}`, body, ECOM)).data;

export const usd = (v: number | string | null | undefined) => `$${Number(v ?? 0).toFixed(2)}`;

export interface ProductoWebT {
  producto_id: string; codigo: string; nombre: string; precio_base: number;
  web_id: string | null; titulo: string | null; slug: string | null; descripcion: string | null;
  seo_titulo: string | null; seo_descripcion: string | null;
  publicado: boolean; destacado: boolean; orden: number;
  precio_web: number | null; disponible: number | null; tiene_imagen: boolean;
}
export interface ColeccionT {
  id: string; slug: string; nombre: string; descripcion: string | null;
  orden: number; publicada: boolean; productos: string[];
}
export interface PedidoT {
  id: string; codigo: string; estado: string; cliente: string; email: string | null;
  telefono: string | null; total: number; pago_metodo: string; entrega_metodo: string;
  zona: string | null; tiene_comprobante: boolean; ticket_id: string | null;
  created_at: string; expira_at: string | null;
}

export const ESTADO_PEDIDO_BADGE: Record<string, string> = {
  pendiente_pago: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  pagado: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  en_preparacion: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  enviado: 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300',
  entregado: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  cancelado: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  reembolsado: 'bg-muted text-muted-foreground',
};
